import { WhichWeightAPI } from 'WhichWeightAPI';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOrganizationAssessments } from 'redux/slices/organization';

export const useGetAssessments = () => {
    
    const dispatch = useDispatch();

    const userId = useSelector(state => state.user.id);
    const organizationId = useSelector(state => state.user.organizationId);
    const cachedAssessments = useSelector(state => state.organization.assessments);
    
    const [assessments, setAssessments] = useState(cachedAssessments);

    const FetchAssessmentsFromBackend = async () => {
        const jsonBody = {
            organizationId: organizationId,
            requestingUserId: userId
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('CORE', 'GET', '/organization_assessments', jsonBody)

        // console.log(result.data.data);

        if (result.data.status === "failure") {
            console.error(result.data);
            dispatch(setOrganizationAssessments([]));
            setAssessments([]);
            return;
        }

        dispatch(setOrganizationAssessments(result.data.data));
        setAssessments(result.data.data);
    };

    useEffect(() => {
        if (userId === null) return;
        if (organizationId === null) return;

        if (cachedAssessments === null) {
            FetchAssessmentsFromBackend();
        }
    }, [cachedAssessments, dispatch]);

    return assessments;
};
